module.exports = __webpack_public_path__ + "img/eye.54f81faf.svg";